import type { FaireProductEntity } from "../../entity_types/product";

export const p_gsw52n8ffw: FaireProductEntity = {
  token: "p_gsw52n8ffw",
  type: "product",
  name: "Butter Dish with Lid 6.5\"L w/ Butter Knife Hummingbird Design (4/32)",
  brandToken: "b_m8c3mbnsfa",
  brandName: "Urban Tokyo",
  imageUrl: "https://cdn.faire.com/fastly/384a79bc814ff6be221d7abf41f0329196868947f3cfaa844ec2a76dc0ba0045.png",
  galleryImageUrls: [],
  priceDollars: 10,
  description: "Size: 6.5\"L x 3.8\"W x 3\"H\n\nMaterial: Ceramic with Bamboo Lid\n\nCase Pack: 32\n\nOrigin: China\n",
  tags: [],
  msrpDollars: 22.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:02:48.716Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
